const $ = window.jQuery;

function getSelect2Options() {
    // Custom scrollbar for select2, adjust styles here
    $( '.select2-results__options' ).niceScroll( {
        cursorcolor: '#222b41',
        cursorborder: '0',
        cursorborderradius: '0',
        cursorwidth: '3px',
        railpadding: {
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
        },
    } );
}

function initSelect2() {
    const selectItems = [
        '.select-field',
        '.facetwp-type-dropdown',
        // Add or update select parent classes
    ];

    const selectField = $( selectItems.join( ', ' ) ).find( 'select' );

    selectField.each( function() {
        $( this ).select2( {
            width: '100%',
            theme: 'gesec',
            minimumResultsForSearch: -1,
        } ).on( 'select2:open', () => {
            getSelect2Options();
        } );
    } );

    // Shitty hack to prevent FORMIDABLE FORMS use his fucking !important in his style
    setTimeout( () => {
        $( '.select2-hidden-accessible' ).attr( 'style', 'width: 1px !important;' );
    }, 0 );
}

export default () => {
    initSelect2();

    $( document ).on( 'frmAfterAddRow frmPageChanged facetwp-loaded', () => {
        initSelect2();
    } );
};
